/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePendingPaymentDto,
  ErrorMessage,
  InitiatePendingPaymentResponse,
  PendingPaymentPollDto,
  SettlePendingPaymentDto,
  SplitByAmountSuccessResponse,
} from '../models';
import {
    CreatePendingPaymentDtoFromJSON,
    CreatePendingPaymentDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    InitiatePendingPaymentResponseFromJSON,
    InitiatePendingPaymentResponseToJSON,
    PendingPaymentPollDtoFromJSON,
    PendingPaymentPollDtoToJSON,
    SettlePendingPaymentDtoFromJSON,
    SettlePendingPaymentDtoToJSON,
    SplitByAmountSuccessResponseFromJSON,
    SplitByAmountSuccessResponseToJSON,
} from '../models';

export interface CancelPendingPaymentRequest {
    locationId: string;
    paymentMethodId: string;
    pendingPaymentId: number;
}

export interface CreatePendingPaymentRequest {
    locationId: string;
    paymentMethodId: string;
    createPendingPaymentDto: CreatePendingPaymentDto;
}

export interface GetPendingPaymentStateRequest {
    locationId: string;
    paymentMethodId: string;
    pendingPaymentId: number;
}

export interface PayPendingPaymentRequest {
    locationId: string;
    paymentMethodId: string;
    settlePendingPaymentDto: SettlePendingPaymentDto;
}

export interface PollRequest {
    locationId: string;
    paymentMethodId: string;
}

/**
 * 
 */
export class PendingPaymentControllerApi extends runtime.BaseAPI {

    /**
     */
    async cancelPendingPaymentRaw(requestParameters: CancelPendingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling cancelPendingPayment.');
        }

        if (requestParameters.paymentMethodId === null || requestParameters.paymentMethodId === undefined) {
            throw new runtime.RequiredError('paymentMethodId','Required parameter requestParameters.paymentMethodId was null or undefined when calling cancelPendingPayment.');
        }

        if (requestParameters.pendingPaymentId === null || requestParameters.pendingPaymentId === undefined) {
            throw new runtime.RequiredError('pendingPaymentId','Required parameter requestParameters.pendingPaymentId was null or undefined when calling cancelPendingPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/softpay/pending-payments/{locationId}/terminals/{paymentMethodId}/state/{pendingPaymentId}/cancel`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(requestParameters.paymentMethodId))).replace(`{${"pendingPaymentId"}}`, encodeURIComponent(String(requestParameters.pendingPaymentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async cancelPendingPayment(requestParameters: CancelPendingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.cancelPendingPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createPendingPaymentRaw(requestParameters: CreatePendingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiatePendingPaymentResponse>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling createPendingPayment.');
        }

        if (requestParameters.paymentMethodId === null || requestParameters.paymentMethodId === undefined) {
            throw new runtime.RequiredError('paymentMethodId','Required parameter requestParameters.paymentMethodId was null or undefined when calling createPendingPayment.');
        }

        if (requestParameters.createPendingPaymentDto === null || requestParameters.createPendingPaymentDto === undefined) {
            throw new runtime.RequiredError('createPendingPaymentDto','Required parameter requestParameters.createPendingPaymentDto was null or undefined when calling createPendingPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/softpay/pending-payments/{locationId}/terminals/{paymentMethodId}`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(requestParameters.paymentMethodId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePendingPaymentDtoToJSON(requestParameters.createPendingPaymentDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiatePendingPaymentResponseFromJSON(jsonValue));
    }

    /**
     */
    async createPendingPayment(requestParameters: CreatePendingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiatePendingPaymentResponse> {
        const response = await this.createPendingPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPendingPaymentStateRaw(requestParameters: GetPendingPaymentStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PendingPaymentPollDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling getPendingPaymentState.');
        }

        if (requestParameters.paymentMethodId === null || requestParameters.paymentMethodId === undefined) {
            throw new runtime.RequiredError('paymentMethodId','Required parameter requestParameters.paymentMethodId was null or undefined when calling getPendingPaymentState.');
        }

        if (requestParameters.pendingPaymentId === null || requestParameters.pendingPaymentId === undefined) {
            throw new runtime.RequiredError('pendingPaymentId','Required parameter requestParameters.pendingPaymentId was null or undefined when calling getPendingPaymentState.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/softpay/pending-payments/{locationId}/terminals/{paymentMethodId}/state/{pendingPaymentId}`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(requestParameters.paymentMethodId))).replace(`{${"pendingPaymentId"}}`, encodeURIComponent(String(requestParameters.pendingPaymentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PendingPaymentPollDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPendingPaymentState(requestParameters: GetPendingPaymentStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PendingPaymentPollDto> {
        const response = await this.getPendingPaymentStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async payPendingPaymentRaw(requestParameters: PayPendingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SplitByAmountSuccessResponse>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling payPendingPayment.');
        }

        if (requestParameters.paymentMethodId === null || requestParameters.paymentMethodId === undefined) {
            throw new runtime.RequiredError('paymentMethodId','Required parameter requestParameters.paymentMethodId was null or undefined when calling payPendingPayment.');
        }

        if (requestParameters.settlePendingPaymentDto === null || requestParameters.settlePendingPaymentDto === undefined) {
            throw new runtime.RequiredError('settlePendingPaymentDto','Required parameter requestParameters.settlePendingPaymentDto was null or undefined when calling payPendingPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/softpay/pending-payments/{locationId}/terminals/{paymentMethodId}/pay`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(requestParameters.paymentMethodId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SettlePendingPaymentDtoToJSON(requestParameters.settlePendingPaymentDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SplitByAmountSuccessResponseFromJSON(jsonValue));
    }

    /**
     */
    async payPendingPayment(requestParameters: PayPendingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SplitByAmountSuccessResponse> {
        const response = await this.payPendingPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async pollRaw(requestParameters: PollRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PendingPaymentPollDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling poll.');
        }

        if (requestParameters.paymentMethodId === null || requestParameters.paymentMethodId === undefined) {
            throw new runtime.RequiredError('paymentMethodId','Required parameter requestParameters.paymentMethodId was null or undefined when calling poll.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/softpay/pending-payments/{locationId}/terminals/{paymentMethodId}`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(requestParameters.paymentMethodId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PendingPaymentPollDtoFromJSON(jsonValue));
    }

    /**
     */
    async poll(requestParameters: PollRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PendingPaymentPollDto> {
        const response = await this.pollRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
